module.exports = __webpack_public_path__ + "img/gongzhong.d8377b79.jpg";